import { DataSource } from '~/Api/DataSource';

export type Type = 'up-to-date' | 'processing' | 'caution';

export const Types = {
	upToDate: 'up-to-date',
	processing: 'processing',
	caution: 'caution',
};

export default class Status {
	type: Type;

	dataSource: DataSource;

	validFrom: Date | null;

	retrievedAt: Date | null;

	availableSince: Date | null;

	nextEstimatedUpdate: Date | null;

	lastUpdateAt: Date;

	constructor(
		type: Type,
		dataSource: DataSource,
		validFrom: Date | null,
		retrievedAt: Date | null,
		availableSince: Date | null,
		nextEstimatedUpdate: Date | null,
		lastUpdateAt: Date
	) {
		this.type = type;
		this.dataSource = dataSource;
		this.validFrom = validFrom;
		this.retrievedAt = retrievedAt;
		this.availableSince = availableSince;
		this.nextEstimatedUpdate = nextEstimatedUpdate;
		this.lastUpdateAt = lastUpdateAt;
	}
}
